import { useEffect, useRef, useState } from "react";

export default function useDelayedLoading(loading, options) {
   const delayMs = options?.delayMs ?? 200;
   const minShowMs = options?.minShowMs ?? 400;

   const [shouldShow, setShouldShow] = useState(false);
   const delayTimerRef = useRef(null);
   const hideTimerRef = useRef(null);
   const shownAtRef = useRef(0);

   useEffect(() => {
      const clearScheduled = () => {
         if (delayTimerRef.current) {
            clearTimeout(delayTimerRef.current);
            delayTimerRef.current = null;
         }
         if (hideTimerRef.current) {
            clearTimeout(hideTimerRef.current);
            hideTimerRef.current = null;
         }
      };

      if (loading) {
         if (shouldShow || delayTimerRef.current) return undefined;
         delayTimerRef.current = setTimeout(() => {
            delayTimerRef.current = null;
            shownAtRef.current = Date.now();
            setShouldShow(true);
         }, Math.max(0, delayMs));
         return clearScheduled;
      }

      if (delayTimerRef.current) {
         clearTimeout(delayTimerRef.current);
         delayTimerRef.current = null;
      }

      if (!shouldShow) return undefined;

      const elapsed = Date.now() - shownAtRef.current;
      const remaining = Math.max(0, minShowMs - elapsed);
      hideTimerRef.current = setTimeout(() => {
         hideTimerRef.current = null;
         setShouldShow(false);
      }, remaining);

      return clearScheduled;
   }, [loading, delayMs, minShowMs, shouldShow]);

   useEffect(() => {
      return () => {
         if (delayTimerRef.current) clearTimeout(delayTimerRef.current);
         if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      };
   }, []);

   return shouldShow;
}
